import React, {
  useEffect,
  useRef,
  useState
} from "react";
import MarketingDocGate from "../MarketingDocGate";

import { conversions } from "../data";

import { eventNameError, lengthError } from "../../utils/validation";
import {
  Drawer,
  FormField,
  PageHeader,
  Select,
  Toggle
} from "../components/Shared";


function Conversions({ initial = {}, onSave }) {

  const initialRows = useRef(initial.rows || conversions);
  const [rows, setRows] =
    useState(initialRows.current);

  // Persist whenever the list changes after load (create, edit and the active toggle all go through setRows).
  useEffect(() => {
    if (rows === initialRows.current) return;
    onSave({ rows }).catch((error) => window.alert(error.message || "Unable to save your changes."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  const [open, setOpen] =
    useState(false);

  const [edit, setEdit] =
    useState(null);

  const [errors, setErrors] = useState({});


  const create = () => {

    setEdit({
      name: "",
      event: "",
      source: "CTA: Book a demo",
      goal: "Lead",
      status: true
    });

    setErrors({});
    setOpen(true);
  };


  const save = () => {

    const found = {
      name: lengthError(edit.name, { min: 2, max: 80, label: "Conversion name" }),
      event: eventNameError(edit.event),
    };
    setErrors(found);
    if (Object.values(found).some(Boolean)) return;

    setRows((items) => {

      if (edit.id) {

        return items.map((item) =>
          item.id === edit.id
            ? edit
            : item
        );

      }

      return [
        {
          ...edit,
          id: Date.now()
        },
        ...items
      ];

    });

    setOpen(false);
  };


  return (
    <>

      <PageHeader
        eyebrow="MARKETING / ANALYTICS"
        title="Conversion tracking"
        description="Define the visitor actions that should be recorded as conversions."
        action="Create conversion"
        onAction={create}
      />


      <div className="analytics-banner">

        <div className="analytics-icon">

          <i className="bi bi-graph-up-arrow"></i>

        </div>


        <div>

          <strong>
            Conversion tracking is active
          </strong>

          <p>
            Events from configured CTAs and forms
            can be mapped to conversion goals.
          </p>

        </div>


        <button className="btn btn-outline-dark ms-auto">
          View events
        </button>

      </div>


      <div className="table-card">

        <table className="table align-middle mb-0">

          <thead>

            <tr>

              <th>
                Conversion
              </th>

              <th>
                Event name
              </th>

              <th>
                Source
              </th>

              <th>
                Goal
              </th>

              <th>
                Status
              </th>

              <th></th>

            </tr>

          </thead>


          <tbody>

            {rows.map((row) => (

              <tr key={row.id}>

                <td>

                  <div className="cell-title">
                    {row.name}
                  </div>

                </td>


                <td>

                  <code>
                    {row.event}
                  </code>

                </td>


                <td>
                  {row.source}
                </td>


                <td>

                  <span className="goal-tag">
                    {row.goal}
                  </span>

                </td>


                <td>

                  <Toggle
                    label={`Conversion ${row.name} is active`}
                    checked={row.status}
                    onChange={(value) =>
                      setRows((items) =>
                        items.map((item) =>
                          item.id === row.id
                            ? {
                                ...item,
                                status: value
                              }
                            : item
                        )
                      )
                    }
                  />

                </td>


                <td>

                  <button
                    className="row-menu"
                    onClick={() => {

                      setEdit(row);
                      setErrors({});
                setErrors({});
                      setOpen(true);

                    }}
                  >

                    <i className="bi bi-three-dots"></i>

                  </button>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>


      {open && (

        <Drawer
          title={
            edit.id
              ? "Edit conversion"
              : "Create conversion"
          }
          subtitle="Map a frontend event to a conversion goal."
          onClose={() =>
            setOpen(false)
          }
          footer={

            <>

              <button
                className="btn btn-light"
                onClick={() =>
                  setOpen(false)
                }
              >
                Cancel
              </button>

              <button
                className="btn btn-dark"
                onClick={save}
              >
                Save conversion
              </button>

            </>

          }
        >

          <FormField label="Conversion name" error={errors.name}>

            <input
              className="form-control"
              value={edit.name}
              onChange={(e) =>
                setEdit({
                  ...edit,
                  name: e.target.value
                })
              }
              placeholder="Demo booked"
            />

          </FormField>


          <FormField label="Event name" error={errors.event}>

            <input
              className="form-control"
              value={edit.event}
              onChange={(e) =>
                setEdit({
                  ...edit,
                  event: e.target.value
                })
              }
              placeholder="demo_booked"
            />

          </FormField>


          <FormField label="Source">

            <Select
              value={edit.source}
              onChange={(e) =>
                setEdit({
                  ...edit,
                  source: e.target.value
                })
              }
            >

              <option>
                CTA: Book a demo
              </option>

              <option>
                Form
              </option>

              <option>
                Custom event
              </option>

            </Select>

          </FormField>


          <FormField label="Goal">

            <Select
              value={edit.goal}
              onChange={(e) =>
                setEdit({
                  ...edit,
                  goal: e.target.value
                })
              }
            >

              <option>
                Lead
              </option>

              <option>
                Signup
              </option>

              <option>
                Purchase
              </option>

              <option>
                Engagement
              </option>

            </Select>

          </FormField>

        </Drawer>

      )}

    </>
  );
}

export default function ConversionsPage() {
  return <MarketingDocGate section="conversions">{({ doc, save }) => <Conversions initial={doc} onSave={save} />}</MarketingDocGate>;
}
